module.exports = __webpack_public_path__ + "media/general_icons/check_mark_light_green-15a542ef.svg";